export default {
	agreements: {
		title:
			'Bitte bestätigen Sie die aktuellen Fassungen unserer Lizenzverträge.',
		system: {
			title: 'Lizenzvereinbarungen für {{systemName}}'
		},
		version: 'Version: {{version}}',
		publishedDate: 'Stand: {{date}}',
		mainDocument: 'Hauptvertragsdokument',
		attachment: 'Anlage: {{title}}',
		preview: 'VORSCHAU',
		view: 'ANZEIGEN',
		confirmation:
			'Hiermit bestätige ich, dass ich alle Lizenzvereinbarungen samt Anlagen gelesen und akzeptiert habe.',
		acceptButton: 'LIZENZVEREINBARUNGEN AKZEPTIEREN',
		noAgreements: {
			title: 'Keine ausstehenden Lizenzvereinbarungen',
			description:
				'Sie haben derzeit keine offenen Lizenzvereinbarungen, die akzeptiert werden müssen.'
		},
		error: {
			loadFailed: 'Lizenzvereinbarungen konnten nicht geladen werden.',
			acceptFailed:
				'Akzeptierung fehlgeschlagen. Bitte versuchen Sie es erneut.'
		},
		loading: 'Laden...',
		accepting: 'Akzeptiere...'
	},
	contracts: {
		title: 'Lizenzvereinbarungen',
		empty: 'Keine Lizenzvereinbarungen vorhanden',
		loading: 'Laden...',
		error: 'Fehler beim Laden der Lizenzvereinbarungen',
		generalFacilities: 'Allgemeine Vertragsanlagen',
		download: 'Dokument herunterladen',
		downloadSuccess: 'Dokument erfolgreich heruntergeladen',
		documents: 'Dokumente',
		noDocuments: 'Keine Dokumente vorhanden',
		updatedMarker: ' (aktualisiert)',
		viewUpdatedText: 'Aktualisierten Text anzeigen: {{title}}',
		viewUpdatedTextFallback: 'Aktualisierten Text anzeigen',
		finishedAt: 'Abgeschlossen am',
		downloadAllContracts: 'Alle Vertragsdateien herunterladen'
	},
	status: {
		awaiting_signatures: 'Wartet auf Unterschriften',
		finished: 'Abgeschlossen'
	},
	download: {
		error:
			'Fehler beim Herunterladen des Dokuments. Bitte versuchen Sie es erneut.'
	}
}
